class ItauService {
  static isItiAccount(agency) {
    return Number(agency) === 500;
  }
}

module.exports = ItauService;
